import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import LandingPage from "./pages/LandingPage";
import ProductPage from "./pages/ProductPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import "./App.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useSiteContent = () =>
  useQuery({
    queryKey: ["site-content"],
    queryFn: async () => (await axios.get(`${API}/content`)).data,
    staleTime: 30_000,
  });

const ScrollManager = () => {
  const lenisRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    lenisRef.current?.scrollTo(0, { immediate: true });
  }, [location.pathname]);

  return null;
};

function App() {
  return (
    <div className="grain-overlay bg-[#0B0D10] min-h-screen">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/printed-cardboard-tubes/:slug" element={<ProductPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: { background: "#14171D", border: "1px solid rgba(212,175,55,0.2)", color: "#F5F3EF" },
        }}
      />
    </div>
  );
}

export default App;
